import React from 'react'

/**
 * The full Invision360 QA logo.
 *
 * @param {boolean} variant - 'light' or 'dark' to control which logo is shown. Defaults to dark.
 */
export const FullQALogo = ({ variant = 'dark', ...props }) => {
  return <img src={variant === 'dark' ? '/qa-logo-dark.svg' : '/qa-logo-light.svg'} alt='Invision360 QA Logo' {...props}></img>
}
